/** Tipos da Pessoa */
export interface PessoaTipo {
    id: number;
    nome: string;
    abreviacao: string;
    descricao: string;
    iconClass: string;
}

export const pessoaFisica: PessoaTipo = {
    id: 1,
    nome: 'Física',
    abreviacao: 'CPF',
    descricao: 'Indivíduo que possui um CPF',
    iconClass: 'fas fa-user'
};
export const pessoaJuridica: PessoaTipo = {
    id: 2,
    nome: 'Jurídica',
    abreviacao: 'CNPJ',
    descricao: 'Entidade jurídica que possui um CNPJ',
    iconClass: 'fas fa-building'
};
export const pessoaCentralCompras: PessoaTipo = {
    id: 3,
    nome: 'Central de Compras',
    abreviacao: 'CC',
    descricao: 'Agrupamento de empresas (participantes) com o objetivo de centralizar suas compras e que fazem a distruição internamente',
    iconClass: 'fas fa-warehouse'
};

export const pessoaTipos: PessoaTipo[] = [
    pessoaFisica,
    pessoaJuridica,
    pessoaCentralCompras
];

/** Verifica se o tipo da pessoa é Fisica */
export function isTipoPessoaFisica(tipo: number): boolean {
    return tipo === pessoaFisica.id;
}

/** Verifica se o tipo da pessoa é Juridica */
export function isTipoPessoaJuridica(tipo: number): boolean {
    return tipo === pessoaJuridica.id;
}

/** Verifica se o tipo da pessoa é Fisica ou Juridica */
export function isTipoPessoaFisicaOuJuridica(tipo: number): boolean {
    return isTipoPessoaFisica(tipo) || isTipoPessoaJuridica(tipo);
}

/** Verifica se o tipo da pessoa é Central de Compras */
export function isTipoPessoaCentralCompras(tipo: number): boolean {
    return tipo === pessoaCentralCompras.id;
}
